import * as React from 'react';
import moment from 'moment';
import { useCurrentLanguage } from '@lumahealthhq/ui-utils';
moment.updateLocale('en', {
  relativeTime: {
    hh: '%d h',
    mm: '%d min',
    s: 'seconds'
  }
});
function useRelativeTime() {
  var currentLanguage = useCurrentLanguage();
  var getRelativeTimeIntl = React.useCallback(function (targetTime) {
    var language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : currentLanguage;
    return targetTime ? moment(targetTime).locale(language).fromNow() : '-';
  }, [currentLanguage]);
  return {
    getRelativeTimeIntl: getRelativeTimeIntl
  };
}
export default useRelativeTime;